// extracted by mini-css-extract-plugin
export default {"root":"MobileViewerTxt__root--2p-Qy","content":"MobileViewerTxt__content--Ha65e"};